const ckEditorToolbar = [
    'heading', '|', 'undo', 'redo', '|', 'insertTable','|', 'bold', 'italic', 'bulletedList', 'NumberedList', '|', 'blockQuote'
]

const table = {
    contentToolbar: [
        'tableColumn',
        'tableRow',
        'mergeTableCells'
    ]
}

const ckEditorConfig = {
    toolbar: ckEditorToolbar,
    table: table
}

export default ckEditorConfig